module.exports = __webpack_public_path__ + "static/img/14000078.f8236f75.png";